import React, { useEffect, useState } from "react";
import { Spin } from "antd";
import { Field, FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useFilter } from "../../../../context/FilterContext";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomFlatpickr from "../../../CustomControls/CustomFlatpickr";
import CustomSelectAsync from "../../../CustomControls/CustomSelectAsync";
import moment from "moment";
import {
  POST_GetCustomerContactPersonDDL,
  POST_GetCustomerContactPersonsListByInvoiceIDs,
  POST_GetCustomerDDLListAJAX,
  POST_GetPaymentReceiptList,
  POST_GetPaymentReceiptPrint,
  POST_PaymentReceiptCancel,
  POST_PaymentReceiptExport,
  POST_PaymentReceiptWhatsAppMessageSend,
} from "../../../helpers/url_helper";
import CustomSizePerPage from "../../../CustomControls/CustomSizePerPage";
import CustomPaginationButtons from "../../../CustomControls/CustomPaginationButtons";
import { post } from "../../../helpers/api_helper";
import { SVGICON } from "../../../constant/theme";
import {
  cleanCsvString,
  errorMessage,
  successMessage,
  warningMessage,
} from "../CommonFunctions";
import CustomSelect from "../../../CustomControls/CustomSelect";

const PaymentReceipt = () => {
  const { filter, updateFilter } = useFilter();

  const isFilterExpanded =
    JSON.parse(localStorage.getItem("userDetails"))?.IsFilterExpanded === true;
  const [showFilter, setShowFilter] = useState(isFilterExpanded);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(
    filter && filter?.page == "payment-receipt" ? filter?.CurrentPage : 1
  );
  const [currentSizePerPage, setCurrentSizePerPage] = useState(
    filter && filter?.page == "payment-receipt" ? filter?.PageSize : 10
  );
  const [recordCount, setRecordCount] = useState(0);

  const [sortBy, setSortBy] = useState(
    filter && filter?.page == "payment-receipt" ? filter?.sortBy : ""
  );
  const [orderBy, setOrderBy] = useState(
    filter && filter?.page == "payment-receipt" ? filter?.orderBy : "asc"
  );

  const [isReset, setIsReset] = useState(false);

  const [paymentReceiptList, setPaymentReceiptList] = useState([]);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));
  const formsList = AuthUser?.Permissions?.FormList;

  const handleClickSorting = (columnName) => {
    setCurrentPage(1);
    if (sortBy == columnName) {
      if (orderBy == "asc") {
        setOrderBy("desc");
      } else {
        setSortBy("");
        setOrderBy("asc");
      }
    } else {
      setSortBy(columnName);
      setOrderBy("asc");
    }
  };

  const validationSchemaFilter = Yup.object().shape({});

  const formikFilter = useFormik({
    validationSchema: validationSchemaFilter,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitFilter(values, formikHelpers),
    initialValues: {
      PaymentReceiptNo:
        filter && filter?.page == "payment-receipt"
          ? filter?.PaymentReceiptNo
          : "",
      FromDate:
        filter && filter?.page == "payment-receipt"
          ? filter?.FromDate
          : new Date(),
      ToDate:
        filter && filter?.page == "payment-receipt"
          ? filter?.ToDate
          : new Date(),
      InvoiceNo:
        filter && filter?.page == "payment-receipt" ? filter?.InvoiceNo : "",
      InwardNo:
        filter && filter?.page == "payment-receipt" ? filter?.InwardNo : "",
      TCNo: filter && filter?.page == "payment-receipt" ? filter?.TCNo : "",
      CustomerIDEncrypted:
        filter && filter?.page == "payment-receipt"
          ? filter?.CustomerIDEncrypted
          : "",
      CustomerName:
        filter && filter?.page == "payment-receipt" ? filter?.CustomerName : "",
    },
    validateOnBlur: false,
  });

  const {
    handleValidSubmitFilter,
    values: {
      PaymentReceiptNo,
      FromDate,
      ToDate,
      InvoiceNo,
      InwardNo,
      TCNo,
      CustomerIDEncrypted,
      CustomerName,
    },
  } = formikFilter;

  const getResetData = async () => {
    setIsLoading(true);

    // formikFilter.resetForm();
    formikFilter.setValues({
      PaymentReceiptNo: "",
      InvoiceNo: "",
      InwardNo: "",
      TCNo: "",
      FromDate: new Date(),
      ToDate: new Date(),
      CustomerIDEncrypted: "",
      CustomerName: "",
    });

    setCurrentPage(1);
    setSortBy("");
    setOrderBy("asc");

    setIsReset(true);
  };

  useEffect(() => {
    if (ToDate && ToDate < FromDate) {
      formikFilter.setFieldValue("ToDate", FromDate);
    }
  }, [FromDate]);

  useEffect(() => {
    if (isReset == true) {
      getData(currentPage, currentSizePerPage);
      setIsReset(false);
    }
  }, [isReset]);

  useEffect(() => {
    getData(currentPage, currentSizePerPage);
  }, [sortBy, orderBy]);

  const getData = async (page = 1, sizePerPage = 10) => {
    setIsLoading(true);

    updateFilter({
      page: "payment-receipt",
      CurrentPage: page,
      PageSize: sizePerPage,
      sortBy: sortBy,
      orderBy: orderBy,
      PaymentReceiptNo: PaymentReceiptNo,
      InvoiceNo: InvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate ? FromDate : "",
      ToDate: ToDate ? ToDate : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
      CustomerName: CustomerName,
    });

    let payload = {
      CurrentPage: page,
      PageSize: sizePerPage,
      Search: "",
      Status: -1,
      Sorting: sortBy ? sortBy + " " + orderBy : "",
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PaymentReceiptNo: PaymentReceiptNo,
      InvoiceNo: InvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
    };

    await post(POST_GetPaymentReceiptList, payload)
      .then((response) => {
        setRecordCount(response?.TotalRecordCount);
        setPaymentReceiptList(response?.List);
        setIsLoading(false);
        if (page > 1 && response?.List?.length === 0) {
          setCurrentPage(page - 1);
          getData(page - 1, sizePerPage);
        } else {
          setCurrentPage(page);
        }
        setCurrentSizePerPage(sizePerPage);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });

    setIsLoading(false);
  };

  const exportReport = () => {
    setIsLoading(true);
    let payload = {
      Status: -1,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
      PaymentReceiptNo: PaymentReceiptNo,
      InvoiceNo: InvoiceNo,
      InwardNo: InwardNo,
      TCNo: TCNo,
      FromDate: FromDate
        ? moment(FromDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      ToDate: ToDate
        ? moment(ToDate).format("YYYY-MM-DD").replace(/^\-/, "")
        : "",
      CustomerIDEncrypted: CustomerIDEncrypted,
    };

    post(POST_PaymentReceiptExport, payload)
      .then((response) => {
        if (response?.IsSuccess) {
          window.open(response?.FilePath);
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const getCustomerDDL_AJAX = async (inputValue) => {
    return await post(POST_GetCustomerDDLListAJAX, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      SearchValue: inputValue ?? "",
      TPIFlag: -1, // 0 = Only Customer, 1 = Only TPI,  -1 = All (Customer & TPI both)
    })
      .then((response) => {
        if (response?.IsSuccess) {
          return response?.CustomerDDLList?.map((item) => ({
            label: item.CustomerName,
            value: item.CustomerIDEncrypted,
          }));
        } else {
          return [];
        }
      })
      .catch((error) => {
        console.log(error);
        return [];
      });
  };

  const loadOptionsCustomer = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  const [showCancelReceiptModal, setShowCancelReceiptModal] = useState(false);

  const validationSchemaCancelReceipt = Yup.object().shape({
    CancelReason: Yup.string()
      .trim()
      .required("Cancel Reason is required field"),
  });

  const formikCancelReceipt = useFormik({
    validationSchema: validationSchemaCancelReceipt,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitCancelReceipt(values, formikHelpers),
    initialValues: {
      PaymentReceiptIDEncrypted: "",
      PaymentReceiptNo: "",
      CancelReason: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {},
  } = formikCancelReceipt;

  const cancelPaymentReceipt = (paymentReceiptID, paymentReceiptNo) => {
    formikCancelReceipt.resetForm();
    formikCancelReceipt.setFieldValue("PaymentReceiptNo", paymentReceiptNo);
    formikCancelReceipt.setFieldValue(
      "PaymentReceiptIDEncrypted",
      paymentReceiptID
    );
    setShowCancelReceiptModal(true);
  };

  const handleValidSubmitCancelReceipt = (values) => {
    setIsLoading(true);
    post(POST_PaymentReceiptCancel, {
      PaymentReceiptIDEncrypted: values?.PaymentReceiptIDEncrypted,
      CancelledReason: values?.CancelReason,
      ModifiedByIDEncrypted: AuthUser?.ReferenceIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          getData(currentPage, currentSizePerPage);
          setShowCancelReceiptModal(false);
        } else {
          setIsLoading(false);
          errorMessage(response?.Message);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const printReceipt = async (paymentReceiptID) => {
    setIsLoading(true);
    await post(POST_GetPaymentReceiptPrint, {
      PaymentReceiptIDEncrypted: paymentReceiptID,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          let iframe = document.getElementById("iFramePaymentReceipt");
          if (iframe) {
            iframe.setAttribute("srcDoc", response?.HTMLContents);
            setTimeout(() => {
              iframe.contentWindow.print();
            }, 300);
          }
        } else {
          errorMessage(response?.Message);
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [
    showSendWhatsAppMessagePaymentReceiptModal,
    setShowSendWhatsAppMessagePaymentReceiptModal,
  ] = useState(false);

  const [wAPMContactPersonOptions, setWAPMContactPersonOptions] = useState([]);

  const validationSchemaSendWhatsAppMessagePaymentReceipt = Yup.object().shape(
    {}
  );

  const formikSendWhatsAppMessagePaymentReceipt = useFormik({
    validationSchema: validationSchemaSendWhatsAppMessagePaymentReceipt,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitSendWhatsAppMessagePaymentReceipt(values, formikHelpers),
    initialValues: {
      PaymentReceiptIDEncrypted: "",
      WAPMListOfProjectContactPerson: [],
      WAPMListOfAdditionalContactPerson: [],
      WAPMAdditionalEmailID: "",
      WAPMCustomerIDEncrypted: "",
      WAPMCustomerName: "",
      WAPMCustomerContactPersonIDEncrypted: "",
      WAPMContactPerson: "",
      WAPMDesignation: "",
      WAPMMobileNo: "",
      WAPMEmailID: "",
      WAPMAdditionalMobileNo: "",
      WAPMContactPersonID: "",
    },
    validateOnBlur: false,
  });

  const {
    values: {
      PaymentReceiptIDEncrypted,
      WAPMListOfProjectContactPerson,
      WAPMListOfAdditionalContactPerson,
      WAPMAdditionalEmailID,
      WAPMCustomerIDEncrypted,
      WAPMCustomerName,
      WAPMCustomerContactPersonIDEncrypted,
      WAPMContactPerson,
      WAPMDesignation,
      WAPMMobileNo,
      WAPMEmailID,
      WAPMAdditionalMobileNo,
      WAPMContactPersonID,
    },
  } = formikSendWhatsAppMessagePaymentReceipt;

  const handleValidSubmitSendWhatsAppMessagePaymentReceipt = async (values) => {
    if (values?.PaymentReceiptIDEncrypted) {
      let additionalMobileNumbers = values?.WAPMAdditionalMobileNo?.trim();

      //const isValidFormat = /^[0-9]+(,[0-9]+)*$/.test(additionalMobileNumbers);
      if (values?.WAPMAdditionalMobileNo) {
        const isValidFormat = /^(\d{10})(,\d{10})*$/.test(
          additionalMobileNumbers
        );

        if (!isValidFormat) {
          errorMessage(
            "Please enter valid mobile numbers separated by commas."
          );
          return;
        }
      }
      // let listOfAdditionalMobileNo = values?.WAPMsscAdditionalMobileNo?.trim()
      //   ? cleanCsvString(values?.WAPMsscAdditionalMobileNo)?.split(",")
      //   : [];

      let listOfAdditionalMobileNo = additionalMobileNumbers
        ? cleanCsvString(additionalMobileNumbers)?.split(",")
        : [];

      if (
        values?.WAPMListOfProjectContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        values?.WAPMListOfAdditionalContactPerson?.filter(
          (x) => x.IsSelected == true
        )?.length == 0 &&
        listOfAdditionalMobileNo?.length == 0
      ) {
        warningMessage(
          "Please select contact person or enter additional mobile no to send message!"
        );
      } else {
        setIsLoading(true);

        let MobileNoCsv = "";
        Promise.all(
          values?.WAPMListOfProjectContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          values?.WAPMListOfAdditionalContactPerson?.filter(
            (x) => x.IsSelected == true
          )?.map((x) => {
            MobileNoCsv =
              MobileNoCsv + x.MobileNo + ":::" + x.ContactPersonID + ", ";
          }),
          listOfAdditionalMobileNo?.map((mno) => {
            MobileNoCsv = MobileNoCsv + mno + ":::" + 0 + ", ";
          }),
          (MobileNoCsv = cleanCsvString(MobileNoCsv))
        );

        let payload = {
          BranchIDEncrypted: AuthUser?.BranchIDEncrypt,
          CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
          PaymentReceiptIDEncrypted: values?.PaymentReceiptIDEncrypted,
          CreatedByEncrypted: AuthUser?.ReferenceIDEncrypt,
          MobileNos: MobileNoCsv,
        };

        //console.log("payload", payload);
        //return;

        await post(POST_PaymentReceiptWhatsAppMessageSend, payload)
          .then((response) => {
            if (response?.IsSuccess) {
              successMessage(response?.Message);
              setShowSendWhatsAppMessagePaymentReceiptModal(false);
              getData(currentPage, currentSizePerPage);
            } else {
              errorMessage(response?.Message);
            }
            setIsLoading(false);
          })
          .catch((error) => {
            console.log(error);
            setIsLoading(false);
          });
      }
    } else {
      warningMessage("Something went wrong!");
    }
  };

  const openPaymentReceiptWhatsAppMessageDialog = async (
    paymentReceiptID,
    invoiceIDs
  ) => {
    formikSendWhatsAppMessagePaymentReceipt.resetForm();

    formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
      "PaymentReceiptIDEncrypted",
      paymentReceiptID
    );
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonsListByInvoiceIDs, {
      InvoiceIDs: invoiceIDs,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
            "WAPMListOfProjectContactPerson",
            response?.List?.filter((item) => item.MobileNo !== "")?.map(
              (x) => ({
                ...x,
                IsSelected: false,
              })
            )
          );
        }
        setShowSendWhatsAppMessagePaymentReceiptModal(true);
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const addAdditionalContactPerson_WAPM = () => {
    if (WAPMCustomerIDEncrypted && WAPMCustomerContactPersonIDEncrypted) {
      if (
        WAPMListOfAdditionalContactPerson?.filter(
          (x) =>
            x?.CustomerContactPersonIDEncrypted ==
            WAPMCustomerContactPersonIDEncrypted
        )?.length == 0
      ) {
        formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
          "WAPMListOfAdditionalContactPerson",
          [
            ...WAPMListOfAdditionalContactPerson,
            {
              IsSelected: true,
              CustomerName: WAPMCustomerName,
              CustomerContactPersonIDEncrypted:
                WAPMCustomerContactPersonIDEncrypted,
              ContactPerson: WAPMContactPerson,
              Designation: WAPMDesignation,
              MobileNo: WAPMMobileNo,
              EmailID: WAPMEmailID,
              ContactPersonID: WAPMContactPersonID,
            },
          ]
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
          "WAPMCustomerContactPersonIDEncrypted",
          ""
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
          "WAPMContactPerson",
          ""
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
          "WAPMDesignation",
          ""
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
          "WAPMMobileNo",
          ""
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
          "WAPMEmailID",
          ""
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
          "WAPMContactPersonID",
          ""
        );
      } else {
        //show duplicate error
        warningMessage("Contact Person already exists!");
      }
    } else {
      if (!WAPMCustomerIDEncrypted) {
        formikSendWhatsAppMessagePaymentReceipt.setFieldError(
          "WAPMCustomerIDEncrypted",
          "Customer is required field"
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldTouched(
          "WAPMCustomerIDEncrypted",
          true
        );
      }
      if (!WAPMCustomerContactPersonIDEncrypted) {
        formikSendWhatsAppMessagePaymentReceipt.setFieldError(
          "WAPMCustomerContactPersonIDEncrypted",
          "Contact Person is required field"
        );
        formikSendWhatsAppMessagePaymentReceipt.setFieldTouched(
          "WAPMCustomerContactPersonIDEncrypted",
          true
        );
      }
    }
  };

  const loadOptionsCustomer_email = (inputValue) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(getCustomerDDL_AJAX(inputValue));
      }, 1000);
    });
  };

  useEffect(() => {
    if (WAPMCustomerIDEncrypted) {
      getCustomerContactPersonDDL_email(WAPMCustomerIDEncrypted);
    } else {
      setWAPMContactPersonOptions([]);
      formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
        "WAPMCustomerContactPersonIDEncrypted",
        ""
      );
      formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
        "WAPMContactPerson",
        ""
      );
      formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
        "WAPMDesignation",
        ""
      );
      formikSendWhatsAppMessagePaymentReceipt.setFieldValue("WAPMMobileNo", "");
      formikSendWhatsAppMessagePaymentReceipt.setFieldValue("WAPMEmailID", "");
      formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
        "WAPMContactPersonID",
        ""
      );
    }
  }, [WAPMCustomerIDEncrypted]);

  const getCustomerContactPersonDDL_email = async (customerID) => {
    setIsLoading(true);
    await post(POST_GetCustomerContactPersonDDL, {
      CustomerIDEncrypted: customerID,
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setWAPMContactPersonOptions(
            response?.ListOfContactPersons?.map((item) => ({
              label: item.ContactPerson,
              value: item.CustomerContactPersonIDEncrypted,
              MobileNo: item.MobileNo,
              EmailID: item.EmailID,
              Designation: item.Designation,
              ContactPersonID: item.ContactPersonID,
            }))
          );
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        isLoading(false);
      });
  };

  return (
    <>
      <div className="card m-1">
        <div className="card-body p-1">
          <Spin
            size="large"
            spinning={isLoading}
            tip={"Loading..."}
            style={{ position: "fixed" }}
          >
            <div className="table-responsive active-projects style-1 shorting">
              <div className="tbl-caption p-2">
                <h4 className="heading mb-0">Payment Receipt</h4>
                <div className="d-flex align-items-center">
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getResetData();
                    }}
                  >
                    <i className="fa fa-window-restore me-2" aria-hidden="true"></i>
                    Reset
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={(e) => {
                      getData();
                    }}
                  >
                    <i className="fa-solid fa-refresh me-2"></i> Reload
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-primary btn-sm me-2"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <i className="fa-solid fa-filter me-2"></i>Filter
                  </button>
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 55 && x?.IsExport)
                    ?.length > 0 ? (
                    <Link
                      className="btn btn-outline-primary btn-sm me-2"
                      onClick={exportReport}
                    >
                      <i className="fa-solid fa-file-excel" /> Export Report
                    </Link>
                  ) : (
                    ""
                  )}
                  {AuthUser?.UserType !== 1 ||
                  formsList?.filter((x) => x?.FormID == 55 && x?.IsAdd)
                    ?.length > 0 ? (
                    <Link
                      to="/add-payment-receipt"
                      className="btn btn-outline-primary btn-sm"
                    >
                      <i className="fa-solid fa-plus"></i> Add Payment Receipt
                    </Link>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              <hr className="mt-0 mb-1"></hr>
              <div className="p-2 pt-0 pb-0">
                {showFilter ? (
                  <div>
                    <FormikProvider value={formikFilter}>
                      <Form onSubmit={formikFilter.handleSubmit}>
                        <Row className="me-0">
                          <Col lg={3}>
                            <Field
                              label="Payment Receipt No"
                              name="PaymentReceiptNo"
                              placeholder={"Search Payment Receipt No"}
                              component={CustomInput}
                              autoFocus={isFilterExpanded}
                            />
                          </Col>

                          <Col lg={3}>
                            <label className="mb-1">Payment Date</label>
                            <div className="d-flex">
                              <Field
                                name="FromDate"
                                placeholder={"From Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                }}
                              />
                              <div>&nbsp;</div>
                              <Field
                                name="ToDate"
                                placeholder={"To Date"}
                                component={CustomFlatpickr}
                                options={{
                                  altInput: true,
                                  altFormat: "j-M-Y",
                                  dateFormat: "d-m-Y",
                                  minDate: FromDate,
                                }}
                              />
                            </div>
                          </Col>

                          <Col lg={3}>
                            <Field
                              label="Customer"
                              name="CustomerIDEncrypted"
                              placeholder={"Select Customer"}
                              loadOptionsFn={loadOptionsCustomer}
                              component={CustomSelectAsync}
                              title={CustomerName}
                              labelFieldName="CustomerName"
                              menuPosition="fixed"
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Invoice No"
                              name="InvoiceNo"
                              placeholder={"Search Invoice No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="Inward No"
                              name="InwardNo"
                              placeholder={"Search Inward No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={3}>
                            <Field
                              label="TC No"
                              name="TCNo"
                              placeholder={"Search TC No"}
                              component={CustomInput}
                            />
                          </Col>
                          <Col lg={1}>
                            <label className="mb-1">&nbsp;</label>
                            <div className="d-flex">
                              <div className="d-lg-block">
                                <Link
                                  className="btn btn-primary btn-sm mb-1"
                                  onClick={(e) => {
                                    getData();
                                  }}
                                >
                                  <i
                                    className="fa fa-search"
                                    aria-hidden="true"
                                  ></i>
                                  {"  "} Search
                                </Link>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </FormikProvider>
                  </div>
                ) : (
                  ""
                )}
                <div
                  id="PaymentReceipt-tbl_wrapper"
                  className="dataTables_wrapper no-footer"
                >
                  <table
                    id="PaymentReceipt-tbl"
                    className="table dataTable no-footer mb-0"
                  >
                    <thead>
                      <tr>
                        <th width="6%" style={{ minWidth: "90px" }}></th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("PaymentReceiptNo");
                          }}
                        >
                          Receipt No{" "}
                          <span className="ml-1">
                            {sortBy == "PaymentReceiptNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "7%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("PaymentDate");
                          }}
                        >
                          Payment Date{" "}
                          <span className="ml-1">
                            {sortBy == "PaymentDate" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "15%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CustomerName");
                          }}
                        >
                          Customer Name{" "}
                          <span className="ml-1">
                            {sortBy == "CustomerName" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InvoiceNo");
                          }}
                        >
                          Invoice No{" "}
                          <span className="ml-1">
                            {sortBy == "InvoiceNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("InwardNo");
                          }}
                        >
                          Inward No{" "}
                          <span className="ml-1">
                            {sortBy == "InwardNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "12%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TCNo");
                          }}
                        >
                          TC No{" "}
                          <span className="ml-1">
                            {sortBy == "TCNo" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "6%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("TDSAmount");
                          }}
                        >
                          TDS Amount{" "}
                          <span className="ml-1">
                            {sortBy == "TDSAmount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("Amount");
                          }}
                        >
                          Received Amount{" "}
                          <span className="ml-1">
                            {sortBy == "Amount" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "10%",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            handleClickSorting("CreatedBy");
                          }}
                        >
                          Created By{" "}
                          <span className="ml-1">
                            {sortBy == "CreatedBy" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                        <th
                          style={{
                            width: "8%",
                            cursor: "pointer",
                            textAlign: "left",
                          }}
                          onClick={() => {
                            handleClickSorting("CreatedOn");
                          }}
                        >
                          Created On{" "}
                          <span className="ml-1">
                            {sortBy == "CreatedOn" ? (
                              orderBy == "desc" ? (
                                <i
                                  className="fa fa-arrow-down ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              ) : (
                                <i
                                  className="fa fa-arrow-up ms-2 fs-14"
                                  style={{ opacity: "0.7" }}
                                />
                              )
                            ) : (
                              <i
                                className="fa fa-sort ms-2 fs-14"
                                style={{ opacity: "0.3" }}
                              />
                            )}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentReceiptList?.length > 0 ? (
                        paymentReceiptList?.map((item, indx) => (
                          <tr key={indx}>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 55 && x?.IsEdit
                              )?.length > 0 ? (
                                <Link
                                  to={`/edit-payment-receipt/${window.btoa(
                                    item.PaymentReceiptIDEncrypted
                                  )}`}
                                  className="icon-box icon-box-md me-1"
                                  title="Edit"
                                >
                                  {SVGICON.EditPrimary}
                                </Link>
                              ) : (
                                ""
                              )}
                              <Link
                                to="#"
                                className="icon-box icon-box-md me-1"
                                title="Print"
                                onClick={() => {
                                  printReceipt(item.PaymentReceiptIDEncrypted);
                                }}
                              >
                                {SVGICON.Printer}
                              </Link>

                              {AuthUser?.UserType == 1 &&
                              AuthUser?.Permissions?.Whatsup == 1 &&
                              formsList?.filter(
                                (x) =>
                                  x?.FormID == 81 && (x?.IsAdd || x?.IsEdit)
                              )?.length > 0 ? (
                                <>
                                  <Link
                                    className="icon-box icon-box-md me-1"
                                    title="Send Payment Receipt in WhatsApp"
                                    onClick={() => {
                                      openPaymentReceiptWhatsAppMessageDialog(
                                        item.PaymentReceiptIDEncrypted,
                                        item.InvoiceIDs
                                      );
                                    }}
                                  >
                                    {SVGICON.WhatsApp}
                                  </Link>
                                </>
                              ) : (
                                ""
                              )}

                              {AuthUser?.UserType !== 1 ||
                              formsList?.filter(
                                (x) => x?.FormID == 55 && x?.IsDelete
                              )?.length > 0 ? (
                                <Link
                                  to="#"
                                  className="icon-box icon-box-md me-1"
                                  title="Delete"
                                  onClick={() => {
                                    cancelPaymentReceipt(
                                      item.PaymentReceiptIDEncrypted,
                                      item.PaymentReceiptNo
                                    );
                                  }}
                                >
                                  {SVGICON.DeleteDanger}
                                </Link>
                              ) : (
                                ""
                              )}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.PaymentReceiptNo}
                            </td>
                            <td style={{ verticalAlign: "top" }}>
                              {item.PaymentDate}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.CustomerName}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.InvoiceNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.InwardNo}
                            </td>
                            <td
                              style={{
                                whiteSpace: "normal",
                                verticalAlign: "top",
                              }}
                            >
                              {item.TCNo}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.TDSAmount}
                            </td>
                            <td
                              className="pe-4"
                              style={{
                                textAlign: "right",
                                verticalAlign: "top",
                              }}
                            >
                              {item.Amount}
                            </td>

                            <td style={{ verticalAlign: "top" }}>
                              {item.CreatedBy}
                            </td>
                            <td
                              style={{
                                verticalAlign: "top",
                                textAlign: "left",
                              }}
                            >
                              {item.CreatedDate}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={11} style={{ textAlign: "left" }}>
                            <div>{"No Record Found..."}</div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                  <hr className="mt-0 mb-0"></hr>
                  <div className="d-sm-flex text-center justify-content-between align-items-center">
                    <CustomSizePerPage
                      getData={getData}
                      currentSizePerPage={currentSizePerPage}
                    />
                    <div className="dataTables_info">
                      Showing{" "}
                      {recordCount > 0
                        ? (currentPage - 1) * currentSizePerPage + 1
                        : 0}{" "}
                      to{" "}
                      {recordCount > currentPage * currentSizePerPage
                        ? currentPage * currentSizePerPage
                        : recordCount}{" "}
                      of {recordCount} entries
                    </div>
                    <CustomPaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      currentSizePerPage={currentSizePerPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Spin>
          <Modal
            className="fade"
            show={showCancelReceiptModal}
            onHide={setShowCancelReceiptModal}
            size="lg"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikCancelReceipt}>
                <Form onSubmit={formikCancelReceipt.handleSubmit}>
                  <Modal.Header>
                    <Modal.Title>
                      Cancel Payment Receipt -{" "}
                      {formikCancelReceipt.values.PaymentReceiptNo}
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() => setShowCancelReceiptModal(false)}
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <Row className="ps-2 pe-2">
                      <Col lg={12}>
                        <Field
                          label="Cancel Reason"
                          name="CancelReason"
                          placeholder={"Cancel Reason"}
                          component={CustomInput}
                          maxLength={500}
                          required
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fa-solid fa-floppy-disk"></i> Submit
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() => setShowCancelReceiptModal(false)}
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
          <Modal
            className="fade"
            show={showSendWhatsAppMessagePaymentReceiptModal}
            onHide={setShowSendWhatsAppMessagePaymentReceiptModal}
            size="xl"
            backdrop="static"
          >
            <Spin
              size="large"
              spinning={isLoading}
              tip={"Loading..."}
              style={{ position: "fixed" }}
            >
              <FormikProvider value={formikSendWhatsAppMessagePaymentReceipt}>
                <Form
                  onSubmit={
                    formikSendWhatsAppMessagePaymentReceipt.handleSubmit
                  }
                >
                  <Modal.Header>
                    <Modal.Title>
                      Payment Receipt Send WhatsApp Message
                    </Modal.Title>
                    <Button
                      type="button"
                      variant=""
                      className="btn-close"
                      onClick={() =>
                        setShowSendWhatsAppMessagePaymentReceiptModal(false)
                      }
                    ></Button>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="d-flex justify-content-between mb-2">
                      <h5 className="mb-0">Biling Contact Person</h5>
                    </div>
                    <div className="table-responsive active-projects style-1 shorting">
                      <div
                        id="ProjectBilingContactPersons-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="ProjectBilingContactPersons-tbl"
                          className="table dataTable no-footer"
                        >
                          <thead>
                            <tr>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "3%" }}></th>
                              <th style={{ width: "22%" }}>Customer Name</th>
                              <th style={{ width: "20%" }}>Contact Person</th>
                              <th style={{ width: "16%" }}>Designation</th>
                              <th style={{ width: "16%" }}>Mobile No</th>
                              <th style={{ width: "20%", textAlign: "left" }}>
                                Email
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {WAPMListOfProjectContactPerson?.length > 0 ? (
                              WAPMListOfProjectContactPerson?.map(
                                (item, idx) => (
                                  <tr>
                                    <td>{idx + 1}</td>
                                    <td>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="checkIsSelectedPCP"
                                        checked={item?.IsSelected}
                                        onChange={() => {
                                          formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                                            `WAPMListOfProjectContactPerson[${idx}].IsSelected`,
                                            !item?.IsSelected
                                          );
                                        }}
                                        style={{ cursor: "pointer" }}
                                      ></input>
                                    </td>
                                    <td>{item?.CustomerName}</td>
                                    <td>{item?.ContactPerson}</td>
                                    <td>{item?.Designation}</td>
                                    <td>{item?.MobileNo}</td>
                                    <td style={{ textAlign: "left" }}>
                                      {item?.EmailID}
                                    </td>
                                  </tr>
                                )
                              )
                            ) : (
                              <tr>
                                <td
                                  colSpan={8}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <hr className="mt-1 mb-1"></hr>
                    <Row>
                      <Col lg={3}>
                        <Field
                          label="Customer"
                          name="WAPMCustomerIDEncrypted"
                          placeholder={"Select Customer"}
                          loadOptionsFn={loadOptionsCustomer_email}
                          component={CustomSelectAsync}
                          title={WAPMCustomerName}
                          labelFieldName="WAPMCustomerName"
                          menuPosition="fixed"
                        />
                      </Col>
                      <Col lg={3}>
                        <Field
                          label="Contact Person"
                          name="WAPMCustomerContactPersonIDEncrypted"
                          placeholder={"Select Contact Person"}
                          options={wAPMContactPersonOptions}
                          component={CustomSelect}
                          menuPosition="fixed"
                          onChange={(e) => {
                            formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                              "WAPMCustomerContactPersonIDEncrypted",
                              e?.value ?? ""
                            );
                            formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                              "WAPMContactPerson",
                              e?.label ?? ""
                            );
                            formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                              "WAPMDesignation",
                              e?.Designation ?? ""
                            );
                            formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                              "WAPMMobileNo",
                              e?.MobileNo ?? ""
                            );
                            formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                              "WAPMEmailID",
                              e?.EmailID ?? ""
                            );
                            formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                              "WAPMContactPersonID",
                              e?.ContactPersonID ?? ""
                            );
                          }}
                        />
                      </Col>
                      <Col lg={3}>
                        <div className="mb-2">
                          <label className="mb-1">&nbsp;</label>
                          <div>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={(e) => {
                                addAdditionalContactPerson_WAPM();
                              }}
                            >
                              + Add
                            </button>
                          </div>
                        </div>
                      </Col>
                      <Col lg={12}>
                        <div className="table-responsive active-projects style-1 shorting">
                          <div
                            id="AdditionalContactPerson-tbl_wrapper"
                            className="dataTables_wrapper no-footer"
                          >
                            <table
                              id="AdditionalContactPerson-tbl"
                              className="table dataTable no-footer"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "3%" }}></th>
                                  <th style={{ width: "24%" }}>
                                    Customer Name
                                  </th>
                                  <th style={{ width: "20%" }}>
                                    Contact Person
                                  </th>
                                  <th style={{ width: "20%" }}>Designation</th>
                                  <th style={{ width: "15%" }}>Mobile No</th>
                                  <th
                                    style={{ width: "15%", textAlign: "left" }}
                                  >
                                    Email
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {WAPMListOfAdditionalContactPerson?.length >
                                0 ? (
                                  WAPMListOfAdditionalContactPerson?.filter(
                                    (x) => x.MobileNo !== ""
                                  ).map((item, idx) => (
                                    <tr>
                                      <td>{idx + 1}</td>
                                      <td>
                                        <input
                                          className="form-check-input"
                                          type="checkbox"
                                          id="checkIsSelectedACP"
                                          checked={item?.IsSelected}
                                          onChange={() => {
                                            formikSendWhatsAppMessagePaymentReceipt.setFieldValue(
                                              `WAPMListOfAdditionalContactPerson[${idx}].IsSelected`,
                                              !item?.IsSelected
                                            );
                                          }}
                                          style={{ cursor: "pointer" }}
                                        ></input>
                                      </td>
                                      <td>{item?.CustomerName}</td>
                                      <td>{item?.ContactPerson}</td>
                                      <td>{item?.Designation}</td>
                                      <td>{item?.MobileNo}</td>
                                      <td style={{ textAlign: "left" }}>
                                        {item?.EmailID}
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td
                                      colSpan={7}
                                      style={{
                                        textAlign: "left",
                                      }}
                                    >
                                      <div>{"No Record Found..."}</div>
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={6}>
                        <Field
                          //type="number"
                          label="Additional Mobile No"
                          name="WAPMAdditionalMobileNo"
                          placeholder={
                            "Enter Additional Mobile No like 1234567890,0987654321"
                          }
                          component={CustomInput}
                        />
                      </Col>
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary btn-sm" type="submit">
                      <i className="fab la-whatsapp me-2" /> Send Message
                    </Button>
                    <Button
                      variant="danger btn-sm"
                      onClick={() =>
                        setShowSendWhatsAppMessagePaymentReceiptModal(false)
                      }
                    >
                      <i className="fa fa-cancel"></i> Cancel
                    </Button>
                  </Modal.Footer>
                </Form>
              </FormikProvider>
            </Spin>
          </Modal>
        </div>
      </div>
      <div style={{ display: "none" }}>
        <iframe
          id={`iFramePaymentReceipt`}
          title="Payment Receipt"
          width="100%"
          style={{ height: "100vh", display: "none" }}
          frameBorder="0"
          srcDoc=""
        ></iframe>
      </div>
    </>
  );
};

export default PaymentReceipt;
